import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import ruFallback from './locales/ru.json';

const SITE = import.meta.env.VITE_SITE || 'ru';
const DEFAULT_LOCALE = SITE === 'int' ? 'en' : 'ru';

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: DEFAULT_LOCALE,
    fallbackLng: 'ru',
    defaultNS: 'translation',
    ns: ['translation'],

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: '/api/v1/i18n/{{lng}}',
      parse: (data: string) => {
        try {
          const parsed = JSON.parse(data);
          return parsed.translations || parsed;
        } catch {
          return {};
        }
      },
      requestOptions: {
        cache: 'default',
      },
    },

    partialBundledLanguages: true,
    resources: {
      ru: {
        translation: ruFallback,
      },
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
